import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Form, Input, Button, notification } from 'antd';
import { AUTH_STATUS, useAuth } from '../../auth';

const layout = {
    labelCol: { span: 20 },
    wrapperCol: { span: 24 },
};
const tailLayout = {
    wrapperCol: { offset: 0, span: 6 },
};

/**
 *  
 * @returns 
 */
const FormLogin = () => {
    const history = useHistory();
    const location = useLocation();
    const auth = useAuth();
    const isSubmitting = auth.status === AUTH_STATUS.LOADING && auth.loadingReason === 'signin';
    const redirectTo = location.state && location.state.from && location.state.from.pathname
        ? location.state.from.pathname
        : "/courses";

    /**
     *
     * @param {*} values
     */
    const onFinish = async (values) => {
        try {
            await auth.signin(values);
            history.replace(redirectTo);
        } catch (error) {
            notification['error']({
                message: 'Les identifiants saisis ne correspondent pas',
            });
        }
    };

    return (
        <Form {...layout} onFinish={onFinish} >
            <Form.Item name="email" rules={[{ required: true, message: 'Please input your username!' }]} >
                <Input placeholder="Email" />
            </Form.Item>
            <Form.Item name="password" rules={[{ required: true, message: 'Please input your password!' }]} >
                <Input.Password placeholder="Mot de passe" />
            </Form.Item>
            <Form.Item {...tailLayout}>
                <Button type="primary" htmlType="submit" loading={isSubmitting}>
                    CONNEXION
                </Button>
            </Form.Item>
            <div style={{ textAlign: "left" }}>
                <a href="https://www.applicolis.com/#itt_solution_form">Pas de compte, contactez-nous</a>
            </div>
        </Form>
    )
};

export default FormLogin;
